<div class="container-fluid">
    <div class="row">
      <div class="col-sm-2">
        <app-administration-menu-component></app-administration-menu-component>
      </div>
      <div class="col-sm-12">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>  